import React from 'react';
import { GreetingLoadingPlaceholder } from '@cp-shared-10/frontend-ui';
import { withLoadingAndNoConnectionHandler } from 'components/integration-wrapper';
import { GreetingUi } from './ui';
import { useGreeting } from './useGreeting';

const GreetingWithHandlers = withLoadingAndNoConnectionHandler(GreetingUi);

export const Greeting: React.FC = () => {
    const { data: greeting, isLoading } = useGreeting();

    return (
        <GreetingWithHandlers
            isLoading={isLoading}
            greeting={greeting}
            hasError={false}
            loadingPlaceholder={<GreetingLoadingPlaceholder />}
        />
    );
};
